import { ErrorMessage as HookformErrorMessage } from '@hookform/error-message';
import { PlanPicker } from 'components/plan-picker';
import { ErrorMessage, Grid, Stack } from 'components/ui';
import { SubscriptionPlan } from 'lib/api/generated';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';
import { CreateOrgFormData } from '../common';

const Features = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${globalTheme.space[3]};
  justify-content: center;

  ${Grid} {
    width: auto;
  }
`;

interface SubscriptionProps {
  setSelectedPlan?: Function;
  selectedPlan?: SubscriptionPlan;
}

export const Subscription: FC<SubscriptionProps> = ({
  setSelectedPlan,
  selectedPlan,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateOrgFormData>();

  return (
    <Stack space={5}>
      <Controller
        control={control}
        name='plan'
        render={({ field: { onChange } }) => {
          return (
            <PlanPicker
              defaultBillingCycle={selectedPlan?.billing_cycle}
              defaultPlanTier={selectedPlan?.plan_tier}
              enableFrequencyChange
              onChange={(plan: SubscriptionPlan | undefined) => {
                return onChange(plan?.plan_tier);
              }}
            />
          );
        }}
      />
      <HookformErrorMessage name='plan' errors={errors} as={ErrorMessage} />
    </Stack>
  );
};
